import AppHeader from "../../layout/AppHeader";
import Department from '../../xpost/views/register/department/Department.vue';
import DepartmentAdd from '../../xpost/views/register/department/DepartmentAdd.vue';

const DepartmentRoutes = [
    {
        path: "/cadastro/departamento",
        name: "department",
        components: {
            header: AppHeader,
            default: Department
        }
    },
    {
        path: "/cadastro/departamento/adicionar",
        name: "department.add",
        components: {
            header: AppHeader,
            default: DepartmentAdd
        }
    },
    {
        path: '/cadastro/departamento/adicionar/:id',
        name: 'department.edit',
        components: {
            header: AppHeader,
            default: DepartmentAdd
        }
    }
]

export default DepartmentRoutes;